import { Pill } from "@clipboard-health/ui-components";
import {
  INTERVIEW_SCHEDULE_STATUS,
  type InterviewScheduleStatus,
} from "@src/appV2/redesign/WorkerShifts/api/useFetchPaginatedInterviews";
import { isAfter, isBefore } from "date-fns";

interface InterviewScheduleStatusPillProps {
  scheduleStatus: InterviewScheduleStatus;
  interviewStart: Date;
  interviewEnd: Date;
}

const scheduleStatusConfig = {
  [INTERVIEW_SCHEDULE_STATUS.UPCOMING]: {
    label: "Upcoming",
  },
  [INTERVIEW_SCHEDULE_STATUS.IN_PROGRESS]: {
    label: "In Progress",
  },
  [INTERVIEW_SCHEDULE_STATUS.PAST]: {
    label: "Past",
  },
};

/**
 * For CBH, a "in progress" interview is during duration of HT order
 * For workers, a "in progress" interview is during the actual interview time
 */
function calculateStatusForWorker(params: InterviewScheduleStatusPillProps) {
  const { scheduleStatus, interviewStart, interviewEnd } = params;
  if (scheduleStatus !== INTERVIEW_SCHEDULE_STATUS.IN_PROGRESS) {
    return scheduleStatus;
  }

  if (isBefore(new Date(), interviewStart)) {
    return INTERVIEW_SCHEDULE_STATUS.UPCOMING;
  }

  if (isAfter(new Date(), interviewEnd)) {
    return INTERVIEW_SCHEDULE_STATUS.PAST;
  }

  return INTERVIEW_SCHEDULE_STATUS.IN_PROGRESS;
}

export function InterviewScheduleStatusPill(props: InterviewScheduleStatusPillProps) {
  const { scheduleStatus, interviewStart, interviewEnd } = props;

  const calculatedScheduleStatus = calculateStatusForWorker({
    scheduleStatus,
    interviewStart,
    interviewEnd,
  });

  const config = scheduleStatusConfig[calculatedScheduleStatus];

  return <Pill label={config.label} variant="outlined-dark" size="small" />;
}
